import details from "../../../data/details.json";

import { Box, Typography } from "@mui/material";

export default function Header() {
  return (
    <Box
      sx={{
        backgroundColor: "primary.main",
        color: "primary.contrastText",
        height: "130px",
      }}
    >
      <Typography variant="h2">{details.title}</Typography>
      <Typography variant="h4" sx={{ p: 1 }}>
        {details.subtitle}
      </Typography>
    </Box>
  );
}
